import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/Common";
import { AvatarUploader } from "@/components/AvatarUploader";

const FIELDS = [["bank_name", "Nama bank (mis. BCA)"], ["bank_account", "Nomor rekening"], ["bank_holder", "Atas nama"]];
const PUBLIC = [["city", "Kota"], ["instagram", "Instagram (tanpa @)"]];

export default function PhotographerProfile() {
  const { user, setUser } = useAuth();
  const [f, setF] = useState({ name: user.name, bank_name: user.bank_name || "", bank_account: user.bank_account || "", bank_holder: user.bank_holder || "",
    bio: user.bio || "", city: user.city || "", instagram: user.instagram || "" });

  const save = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.put("/me/profile", f);
      setUser({ ...data, avatar_version: data.avatar_version ?? user.avatar_version });
      toast.success("Profil disimpan");
    } catch (err) {
      toast.error(formatErr(err));
    }
  };

  return (
    <main className="max-w-xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <PageHeader label="Profil publik & pembayaran" title="Profil & Rekening">
        <Link to={`/studio/${user.id}`} className="text-sm font-semibold text-blue-600" data-testid="profile-public-link">Lihat profil publik</Link>
      </PageHeader>
      <AvatarUploader />
      <form onSubmit={save} className="space-y-6">
        <section className="rounded-2xl bg-white border border-zinc-200 p-8 space-y-5">
          <p className="text-xs uppercase tracking-widest text-zinc-400 font-bold">Profil publik</p>
          <div className="space-y-2"><Label>Nama studio</Label><Input required className="h-11 rounded-xl" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="profile-name-input" /></div>
          {PUBLIC.map(([k, l]) => (
            <div key={k} className="space-y-2"><Label>{l}</Label><Input className="h-11 rounded-xl" value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`profile-${k}-input`} /></div>
          ))}
          <div className="space-y-2"><Label>Bio</Label><Textarea rows={4} className="rounded-xl" value={f.bio} onChange={(e) => setF({ ...f, bio: e.target.value })} data-testid="profile-bio-input" /></div>
        </section>
        <section className="rounded-2xl bg-white border border-zinc-200 p-8 space-y-5">
          <p className="text-xs uppercase tracking-widest text-zinc-400 font-bold">Rekening bank</p>
          {FIELDS.map(([k, l]) => (
            <div key={k} className="space-y-2">
              <Label>{l}</Label>
              <Input required className="h-11 rounded-xl" value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`profile-${k.replace("_", "-")}-input`} />
            </div>
          ))}
        </section>
        <Button className="w-full h-11 rounded-xl bg-blue-600 hover:bg-blue-700" data-testid="profile-save-button">Simpan</Button>
      </form>
    </main>
  );
}
